module.exports = __webpack_public_path__ + "img/baby5.30cbd698.jpg";